/**
 * The "On the call" banner's Join (decisions 142, 150; booking-contracts.md section 12), in the Action card's
 * words (165): "Ana is on the call", with Join as the primary on every screen (item 3, 4 Nov). For a lesson the
 * person may be rung on their phone, and joining here stops that ring (stopRinging, before the call opens) and
 * opens the lesson's call page. A call in the pair's room outside any lesson never rings: Join, to the pair's
 * room. A conversation's call opens over the screen.
 */
export function bannerJoin(c: { bookingId?: string | null; roomId: string }): {
  label: string; stopRingFor: string | null; to: string | null;
} {
  if (c.bookingId) return { label: 'Join', stopRingFor: c.bookingId, to: `/call/${c.bookingId}` };
  if (c.roomId.startsWith('room_')) return { label: 'Join', stopRingFor: null, to: `/room/${c.roomId}` };
  return { label: 'Join', stopRingFor: null, to: null };
}

/** The banner's line for a lesson (165's Action card): "Ana is on the call"; without a name, "On the call". */
export function bannerLine(first: string): string {
  return first ? `${first} is on the call` : 'On the call';
}

/**
 * Which lesson a call is: the one its present person's own entry names (the call page writes it as it checks
 * in, on the web and in the apps' web views), else the room's. A pair's room is permanent and keeps the lesson
 * it was first made for, so the room's own is often an old one (item 3, 4 Nov).
 */
export function lessonOfCall(roomBookingId: string | undefined, presentEntryBookingId: string | null | undefined): string | undefined {
  return presentEntryBookingId || roomBookingId;
}
